import {
	PRODUCT_SIMILAR_RECO_REQUEST,
	PRODUCT_SIMILAR_RECO_SUCCESS,
	PRODUCT_SIMILAR_RECO_ERROR,
	PRODUCT_CROSS_VERTICAL_MULTI_REQUEST,
	PRODUCT_CROSS_VERTICAL_MULTI_SUCCESS,
	PRODUCT_CROSS_VERTICAL_MULTI_ERROR,
	PRODUCT_BROWSING_HISTORY_RECO_REQUEST,
	PRODUCT_BROWSING_HISTORY_RECO_SUCCESS,
	PRODUCT_BROWSING_HISTORY_RECO_ERROR
} from 'actions/productRecoAction';
import { INIT } from 'utils/asyncStatusHelper';

import { createReducer } from 'utils/reducerUtils';

const defaultState = {
	asyncStatus: INIT
};

export const productSimilarRecoReducer = createReducer(
	PRODUCT_SIMILAR_RECO_REQUEST,
	PRODUCT_SIMILAR_RECO_SUCCESS,
	PRODUCT_SIMILAR_RECO_ERROR,
	defaultState
);

export const productCrossVerticalRecoReducer = createReducer(
	PRODUCT_CROSS_VERTICAL_MULTI_REQUEST,
	PRODUCT_CROSS_VERTICAL_MULTI_SUCCESS,
	PRODUCT_CROSS_VERTICAL_MULTI_ERROR,
	defaultState
);

export const productBrowsingHistoryRecoReducer = createReducer(
	PRODUCT_BROWSING_HISTORY_RECO_REQUEST,
	PRODUCT_BROWSING_HISTORY_RECO_SUCCESS,
	PRODUCT_BROWSING_HISTORY_RECO_ERROR,
	defaultState
);
